/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { classnames } from "../../utils/text";
import Icon from "../Icon";

// redux
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { getTaskService } from "../../services/task";
import Form from "../Form";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import {
  getTaskByType,
  getTaskLabel,
  isMyCancel,
  isMyApprove,
  setTask as closeTask,
  isCancel
} from "../../utils/task";
import { approvalsHandover, approverTaskCancel, getTaskByPost, taskApproved, taskCancel, taskDenied } from "../../apis/tasks";
import { viewLoading } from "../../utils/loading";
import Comment from "../Comment";
import { taskListReload } from "../../store/actions";
import TaskHandoverPopup from "./TaskHandoverPopup";
import TaskApprovals from "./TaskApprovals";
import { dateToFormat } from "../../utils/date";
import store from "../../store";
import { SET_CARD_LIST } from "../../store/card/actionTypes";
import Button from "../Button";
import { employeeDetailView } from "../../utils/employee";
import { setPrint } from "../../utils/print";
import TaskCommonDraftPrint from "./TaskCommonDraftPrint";
import TaskCommonDraftPrint2 from "./TaskCommonDraftPrint2";
import TaskCommonDraftApprovalPopup from "./TaskCommonDraftApprovalPopup";
import TaskLoad from "./TaskLoad";

const Task = (props) => {
  const { selectedData, employee } = useSelector(
    (store) => ({
      selectedData: store.CardPurchase.selectedData,
      employee: store.Profile.employee
    }),
  );
  const { type, close, mode = 'create', targetIdx: _targetIdx, approvalTargetIdx } = props;
  const targetTask = getTaskByType(type);

  const [targetIdx, setTargetIdx] = useState(_targetIdx);
  const [task, setTask] = useState(null);
  const [taskData, setTaskData] = useState(null);
  const [approverEmployees, setApproverEmployees] = useState([]);
  const [referenceEmployees, setRefererEmployees] = useState([]);

  const [buttons, setButtons] = useState([]);
  // task data
  const [formFields, setFormFields] = useState([]);
  const dispatch = useDispatch();


  // 위임
  const [isApprovalsHandoverPopup, setIsApprovalsHandoverPopup] = useState(false);
  const [employeeSelectedList, setEmployeeSelectedList] = useState([]);

  // 할일 불러오기
  const [selectedTaskOpen, setSelectedTaskOpen] = useState(false);

  // 일반기안
  const [isTaskCommonDraftApprovalPopup, setIsTaskCommonDraftApprovalPopup] = useState(false);

  useEffect(() => {
    setTargetIdx(_targetIdx);
  }, [_targetIdx]);
  const _setTask = async () => {

    let defaultData;
    if (mode !== 'create') {
      if (!type) return alert('TASK 의 mode가 CREATE 타입이 아닌 경우 type은 필수입니다.');

      if (!approvalTargetIdx) {
        if (!targetIdx) return alert('TASK 의 mode가 CREATE 타입이 아닌 경우 targetIdx는 필수입니다.');
        // if (!taskIdx) return alert('TASK 의 mode가 CREATE 타입이 아닌 경우 taskIdx 필수입니다.')
      }

      viewLoading(true);
      try {
        const { data } = await getTaskByPost(
          approvalTargetIdx ?
            { approvalTargetIdx } :
            targetIdx ?
              { postIdx: targetIdx, postType: targetTask.postType } :
              { taskIdx: _targetIdx }
        );
        // const { data } = await getTask(taskIdx)
        defaultData = data;
        setTargetIdx(data.options.postIdx);
        setTaskData(data);
        //console.log('[TASK] component : ', data);

      } catch (error) {
        systemAlert('할일 데이터 호출 실패 : ' + JSON.stringify(error.message));
        viewLoading(false);
        closeTask();
        return;
      }

      viewLoading(false);
    }
    const _task = await getTaskService({
      ...props,
      mode,
      defaultData,
      ...useFormItem,
    });
    setTask(_task);
  };

  useEffect(() => {
    if (type) {
      _setTask();
    }
  }, [type]);


  useEffect(() => {
    if (task) {
      setFormFields(task.fields);
      useFormItem.setValidateFields(task.fields);
      useFormItem.setForm(task.defaultForm);
      useFormItem.setOriginForm(task.defaultForm);
    }
  }, [task]);

  useEffect(() => {
    if (!isEmpty(selectedData) && (task && task.type === "expense_request")) {
      useFormItem.setForm({
        ...task.defaultForm,
        cardPurchase: selectedData,
        useAmt: selectedData.useAmt,
        paymentType: selectedData.orgCd === 'card' ? 'psnl_card' : 'corp_card',
        useTime: [dateToFormat(selectedData.useTime)],
        usePlace: selectedData.useStore,
        ...selectedData.orgCd === 'card' ? { psnlCardUseIdx: selectedData.idx } : { corpCardUseIdx: selectedData.idx },
      });
    }
  }, [selectedData, task]);

  useEffect(() => {
    setButtons([]);
    if (task) {

      setTimeout(() => {
        setButtons([
          {
            isHide: isMyApprove(taskData),
            color: 'text',
            action: _close,
            label: '닫기'
          },
          {
            isHide: !isMyCancel(taskData),
            color: 'red',
            className: 'float-left cancel-btn',
            action: _taskMyCancel,
            label: '취소하기'
          },
          {
            isHide: !isCancel(taskData),
            color: 'red',
            className: 'float-left cancel-btn',
            action: _taskCancel,
            label: '취소하기'
          },
          {
            color: 'green',
            className: 'float-left handover-btn',
            isHide: !isMyApprove(taskData) || task.type === "approval_handover_request",
            action: () => setIsApprovalsHandoverPopup(true),
            label: '위임하기'
          },
          {
            color: 'text',
            className: 'denied-btn',
            isHide: !isMyApprove(taskData),
            action: _taskDenied,
            label: '반려하기'
          },
          {
            isHide: !(isMyApprove(taskData)),
            action: _taskApproved,
            label: '승인하기',
          },
          {
            isHide: mode !== 'create',
            action: useFormItem.handleSubmit,
            label: '작성완료'
          },
        ]);
      });
    }
  }, [task, taskData]);


  const _validate = (form) => {
    return task && task.validate ? task.validate(form) : {};
  };

  const _taskDenied = () => {
    let taskIdx = taskData.myTask.idx;
    let title = `[${task.label}]`;
    title += taskData.approvalTarget.title;
    title += `를(을) 반려 하시겠습니까?`;
    systemAlert(title, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '반려',
          onClick: () => {
            taskDenied(taskIdx).then(() => {
              _close();
              dispatch(taskListReload());
            });
          }
        }
      ]
    });
  };
  const __taskApproved = (data = {}) => {
    let taskIdx = taskData.myTask.idx;
    let title = `[${task.label}]`;
    title += taskData.approvalTarget.title;
    title += `를(을) 승인 하시겠습니까?`;
    systemAlert(title, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            taskApproved(taskIdx, employee?.employeeSign?.idx || null, data.comment)
              .then(() => {
                _close();
                dispatch(taskListReload());
              });
          }
        }
      ]
    });
  }
  const _taskApproved = () => {
    if (task.postType === "common_draft") {
      if (employee?.employeeSign === null) {
        systemAlert("기안 승인은 서명을 등록해야 진행할 수 있습니다.\n나의 정보 - 서명에서 서명 등록 후 진행 해주시길 바랍니다.",
          {
            buttons: [
              { color: "text", label: "취소" },
              { label: "서명등록하기", onClick: () => employeeDetailView(employee.idx) }
            ]
          }
        );
      } else {
        // 일반기안 승인 절차 
        setIsTaskCommonDraftApprovalPopup(true)
      }
    } else {
      __taskApproved()
    };
  };

  const _taskMyCancel = () => {
    let apprTargetIdx = taskData.approvalTarget.idx;
    let title = `[${task.label}]`;
    title += taskData.approvalTarget.title;
    title += `를(을) 취소 하시겠습니까?`;
    systemAlert(title, {
      buttons: [
        {
          color: 'text',
          label: '닫기'
        },
        {
          label: '취소',
          onClick: () => {
            taskCancel(apprTargetIdx)
              .then(() => {
                _close();
                dispatch(taskListReload());
              });
          }
        }
      ]
    });
  };

  const _taskCancel = () => {
    const taskIdx = taskData.myTask.idx;
    const title = `[${task.label}] ${taskData.approvalTarget.title}를(을) 취소 하시겠습니까?${taskData.approvalTarget.type === "work_history_request" ? "\n취소를 진행하면 요청자의 정정일 출퇴근 기록이 삭제됩니다." : ""}`;
    systemAlert(title, {
      buttons: [
        {
          color: 'text',
          label: '닫기'
        },
        {
          label: '취소',
          onClick: () => {
            approverTaskCancel(taskIdx)
              .then(() => {
                _close();
                dispatch(taskListReload());
              });
          }
        }
      ]
    });
  };



  const submit = (data) => {
    let title = task[`${mode}Text`];

    systemAlert(title, {
      buttons: [
        {
          label: '확인', onClick: () => {
            if (task[mode]) {
              task[mode]({
                ...data,
                approverEmployees,
                referenceEmployees
              })
                .then(() => {
                  _close();
                  dispatch(taskListReload());
                  if (task.type === "expense_request") {
                    store.dispatch({
                      type: SET_CARD_LIST,
                      payload: {
                        selectedData: null,
                      }
                    });
                  }
                });
            }
          }
        },
        { label: '취소', color: 'text' }
      ]
    });
  };

  const _close = (e) => {
    if (task.close) {
      task.close(e);
    }
    close(e);
  };

  const useFormItem = useForm(
    {},
    submit,
    _validate
  );

  const taskCommonDraftApprovalSubmit = (data) => {
    __taskApproved(data)
  }

  const approvalsHandoverPopupSubmit = ({ handoverReason, employeeSelectedList }) => {
    let taskIdx = taskData.myTask.idx;

    if (!employeeSelectedList[0]) {
      systemAlert('위임대상을 선택해주세요.');
      return;
    }
    approvalsHandover({
      taskIdxes: [taskIdx],
      handoverTargetEmpIdx: employeeSelectedList[0].idx,
      startDate: "2020-03-03",
      endDate: "2030-10-10",
      reason: handoverReason
    }).then(() => {
      approvalsHandoverPopupClose();
    }).catch(() => { });
  };

  const approvalsHandoverPopupClose = () => {
    setIsApprovalsHandoverPopup(false);
    _close();
    dispatch(taskListReload());
  };

  // useEffect(() => {
  //   console.log(buttons);
  // }, [buttons]);

  // useEffect(() => {
  //   if (!isEmpty(taskData))
  //     setPrint(<TaskCommonDraftPrint2 data={taskData} />)
  // }, [taskData]);

  return <>
    {task &&
      <div className={classnames("task-detail-wrap", `task-detail-${type}`)}>
        <div className="task-contents">
          {!isEmpty(taskData) &&
            <div className="mb-10">{getTaskLabel(taskData)}</div>
          }
          <div className="task-title-wrap">
            <h2 className="task-title">
              <Icon src={task.icon} /> {task.label}
            </h2>
            <div>

              {useFormItem && useFormItem && <>
                {mode === "detail" && type === 'common_draft_request' && (
                  <Button
                    color="line"
                    className={'mr-10'}
                    onClick={() => setPrint(<TaskCommonDraftPrint2 data={taskData} />)
                    }
                  >
                    시행문 인쇄
                  </Button>
                )}
                {mode === "detail" && type === 'common_draft_request' && (
                  <Button
                    color="line"
                    onClick={() => setPrint(<TaskCommonDraftPrint data={taskData} />)
                    }
                  >
                    기안 인쇄
                  </Button>
                )}
              </>}
              {mode === "create" && (
                <Button
                  color="line"
                  onClick={() => setSelectedTaskOpen(true)}
                >
                  불러오기
                </Button>
              )}
            </div>
          </div>
          <div className="task-form-area">
            <div className={`task-form-${task.type}`}>
              {formFields &&
                <Form
                  mode={mode}
                  isRequiredShow={true}
                  fields={formFields}
                  form={useFormItem.form}
                  onChange={useFormItem.handleOnChange}
                  errors={useFormItem.errors}
                  buttons={buttons}
                >
                  {!isEmpty(targetTask) && targetIdx && targetTask.postType &&
                    <Comment
                      postIdx={targetIdx}
                      postType={targetTask.postType}
                    ></Comment>
                  }
                </Form>
              }
            </div>
          </div>
        </div>
        <div className="task-aside">
          <TaskApprovals
            mode={mode}
            taskData={taskData}
            approverEmployees={approverEmployees}
            referenceEmployees={referenceEmployees}
            setApproverEmployees={setApproverEmployees}
            setRefererEmployees={setRefererEmployees}
          ></TaskApprovals>
        </div>
      </div>
    }
    {!isEmpty(taskData) &&
      <TaskCommonDraftApprovalPopup
        isOpen={isTaskCommonDraftApprovalPopup}
        close={() => setIsTaskCommonDraftApprovalPopup(false)}
        taskSelectedList={[taskData]}
        submit={taskCommonDraftApprovalSubmit}
      />
    }
    {!isEmpty(taskData) &&
      <TaskHandoverPopup
        isOpen={isApprovalsHandoverPopup}
        close={approvalsHandoverPopupClose}
        taskSelectedList={[taskData]}
        employeeSelectedList={employeeSelectedList}
        setEmployeeSelectedList={setEmployeeSelectedList}
        submit={approvalsHandoverPopupSubmit}
      />
    }
    {selectedTaskOpen && (
      <>
        <TaskLoad
          open={selectedTaskOpen}
          setOpen={setSelectedTaskOpen}
          task={task}
          useFormItem={useFormItem}
          setTaskData={setTaskData}
        />
      </>
    )}
  </>;
};


export default Task;
